import {useMutation} from '@tanstack/react-query';
import {useAuthStore} from '../store';
import {apiClient} from './apiClient';

export function useAuth() {
  const {setUser, setToken, setLoading, setError, clearUser} = useAuthStore();

  const login = useMutation({
    mutationFn: async ({email, password}) => {
      setLoading(true);
      const response = await apiClient.post('/auth/login', {email, password});
      return response;
    },
    onSuccess: (response) => {
      const {data: user, token} = response.data;
      setUser(user);
      setToken(token);
      setLoading(false);

      // Handle tokens
      // if (rememberMe) {
      //   localStorage.setItem('authToken', JSON.stringify(response.data.token));
      //   localStorage.setItem('userToken', JSON.stringify(response.data.resData));
      // }
    },
    onError: (error) => {
      setError(error.message);
      setLoading(false);
    },
  });

  const register = useMutation({
    mutationFn: async (userData) => {
      setLoading(true);
      const response = await apiClient.post('/auth/register', userData);
      return response;
    },
    onSuccess: () => {
      setLoading(false);
    },
    onError: (error) => {
      setError(error.message);
      setLoading(false);
    },
  });

  const logout = useMutation({
    mutationFn: async () => {
      setLoading(true);
      const response = await apiClient.post('/auth/logout', {});
      return response;
    },
    onSuccess: () => {
      clearUser();
      setLoading(false);
    },
    onError: (error) => {
      setError(error.message);
      setLoading(false);
    },
  });

  const sendverificationCode = useMutation({
    mutationFn: async ({mobile, email}) => {
      const response = await apiClient.post('/auth/sendVerificationCode', {
        mobile,
        email,
      });
      return response.data;
    },
  });

  const verifyVerificationCode = useMutation({
    mutationFn: async ({email, mobile, code}) => {
      const response = await apiClient.post('/auth/verifyVerificationCode', {
        email,
        mobile,
        code,
      });
      return response.data;
    },
  });

  return {login, logout, register, sendverificationCode, verifyVerificationCode};
}
